import {
  SET_MASTER_DATA,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_USER_NAME,
  SET_EMAIL,
  SET_PHONE,
  SET_BIO,
  SET_FB,
  SET_INSTA,
  SET_LINKIN,
  SET_TWI,
  SET_YT,
  SET_BE,
  SET_DRIBBLE,
  SET_PIN,
  SET_DOB,
  SET_GENDER,
  SET_COUNTRY,
  SET_STATE,
  SET_CITY,
  SET_PINCODE,
  SET_IS_PROFILE_LOADER,
  SET_IS_PROFILE_PIC,
  SET_IS_BANNER_PIC,
  SET_USER,
  NOTIFICATION_DATA,
  NOTIFICATION_UPDATE,
  FETCH_CATEGORY,
  IS_MOBILE_SEARCH,
  SET_WEBSITE,
  SET_LANGUAGES,
  REMOVE_LANGUAGES,
} from "../constants";
const initialFormsData = {
  userData: "",
  postCount: "",
  userProfilePic: "",
  uploadProfilePicFile: "",
  bannerImage: "",
  uploadBannerImageFile: "",
  fname: "",
  lname: "",
  username: "",
  email: "",
  gender: "",
  state: "",
  city: "",
  pincode: "",
  website: "",
  phone: "",
  bio: "",
  dob: "",
  fb: "",
  insta: "",
  linkdin: "",
  youtube: "",
  behance: "",
  dribble: "",
  pintrest: "",
  twitter: "",
  country: "",
  blogCount: "",
  questionCount: "",
  isResumeCreated: "",
  educationData: [],
  workData: [],
  certificatedata: [],
  projectdata: [],
  extraCurdata: [],
  publicationdata: [],
  isProfileLoaded: true,
  user: "",
  notificationData: [],
  notificationId: [],
  haveNotification: false,
  categories: [],
  isMobileSearch: false,
  languageSelected: [],
};
const rootData = (state = initialFormsData, action) => {
  switch (action.type) {
    case SET_MASTER_DATA: {
      var count =
        action.payload[0].posts.length >= 0
          ? parseInt(action.payload[0].posts[0].count) +
            parseInt(action.payload[0].posts[1].count)
          : 0;
      return {
        ...state,
        userData: action.payload[0],
        postCount: count,
        userProfilePic: action.payload[0].profile_data.profile_photo,
        bannerImage: action.payload[0].profile_data.banner,
        fname: action.payload[0].profile_data.fname,
        lname: action.payload[0].profile_data.lname,
        username: action.payload[0].profile_data.username,
        email: action.payload[0].profile_data.email,
        gender: action.payload[0].profile_data.gender,
        phone: action.payload[0].profile_data.phone,
        city: action.payload[0].profile_data.city,
        state: action.payload[0].profile_data.state,
        bio: action.payload[0].profile_data.bio,
        dob: action.payload[0].profile_data.dob,
        pincode: action.payload[0].profile_data.pincode,
        fb: action.payload[0].profile_data.fb,
        website: action.payload[0].profile_data.website,
        insta: action.payload[0].profile_data.insta,
        linkdin: action.payload[0].profile_data.linkdin,
        youtube: action.payload[0].profile_data.youtube,
        behance: action.payload[0].profile_data.behance,
        dribble: action.payload[0].profile_data.dribble,
        pintrest: action.payload[0].profile_data.pintrest,
        twitter: action.payload[0].profile_data.twitter,
        country: action.payload[0].profile_data.country,
        isResumeCreated: action.payload[0].resume_status,
        blogCount:
          action.payload[0].posts.length > 0
            ? action.payload[0].posts[0].count
            : 0,
        questionCount:
          action.payload[0].posts.length > 0
            ? action.payload[0].posts[1].count
            : 0,
        educationData: action.payload[0].education_data,
        workData: action.payload[0].work_data,
        certificatedata: action.payload[0].certificate_data,
        projectdata: action.payload[0].projects_data,
        extraCurdata: action.payload[0].extracuricular_data,
        publicationdata: action.payload[0].publication_data,
        languageSelected:
          action.payload[0].profile_data.languages === ""
            ? []
            : JSON.parse(action.payload[0].profile_data.languages),
      };
    }
    case SET_FIRST_NAME: {
      return {
        ...state,
        fname: action.payload,
      };
    }
    case SET_LAST_NAME: {
      return {
        ...state,
        lname: action.payload,
      };
    }
    case SET_USER_NAME: {
      return {
        ...state,
        username: action.payload,
      };
    }
    case SET_EMAIL: {
      return {
        ...state,
        email: action.payload,
      };
    }
    case SET_PHONE: {
      return {
        ...state,
        phone: action.payload,
      };
    }
    case SET_WEBSITE: {
      return {
        ...state,
        website: action.payload,
      };
    }
    case SET_BIO: {
      return {
        ...state,
        bio: action.payload,
      };
    }
    case SET_FB: {
      return {
        ...state,
        fb: action.payload,
      };
    }
    case SET_INSTA: {
      return {
        ...state,
        insta: action.payload,
      };
    }
    case SET_LINKIN: {
      return {
        ...state,
        linkdin: action.payload,
      };
    }
    case SET_TWI: {
      return {
        ...state,
        twitter: action.payload,
      };
    }
    case SET_YT: {
      return {
        ...state,
        youtube: action.payload,
      };
    }
    case SET_BE: {
      return {
        ...state,
        behance: action.payload,
      };
    }
    case SET_DRIBBLE: {
      return {
        ...state,
        dribble: action.payload,
      };
    }
    case SET_PIN: {
      return {
        ...state,
        pintrest: action.payload,
      };
    }
    case SET_DOB: {
      return {
        ...state,
        dob: action.payload,
      };
    }
    case SET_GENDER: {
      return {
        ...state,
        gender: action.payload,
      };
    }
    case SET_COUNTRY: {
      return {
        ...state,
        country: action.payload,
      };
    }
    case SET_STATE: {
      return {
        ...state,
        state: action.payload,
      };
    }
    case SET_CITY: {
      return {
        ...state,
        city: action.payload,
      };
    }
    case SET_PINCODE: {
      return {
        ...state,
        pincode: action.payload,
      };
    }
    case SET_IS_PROFILE_LOADER: {
      state.isProfileLoaded = action.payload;
      return {
        ...state,
      };
    }
    case SET_IS_PROFILE_PIC: {
      var file = action.payload.target.files[0];
      state.userProfilePic = URL.createObjectURL(file);
      state.uploadProfilePicFile = file;
      return {
        ...state,
      };
    }
    case SET_IS_BANNER_PIC: {
      var bannerFile = action.payload.target.files[0];
      state.bannerImage = URL.createObjectURL(bannerFile);
      state.uploadBannerImageFile = bannerFile;
      return {
        ...state,
      };
    }
    case SET_USER: {
      state.user = action.payload;
      return {
        ...state,
      };
    }
    case NOTIFICATION_DATA: {
      state.notificationData = action.payload;
      {
        state.notificationData &&
          state.notificationData?.map((notifiyBool) => {
            if (notifiyBool.view_status === "0") {
              state.haveNotification = true;
            }
          });
      }
      return {
        ...state,
      };
    }
    case NOTIFICATION_UPDATE: {
      // state.notificationData?.map((notifyData) => {
      //   if (notifyData.view_status === "0") {
      //     state.notificationId.push(notifyData.notification_id);
      //   }
      // });
      // state.haveNotification = false;
      return {
        ...state,
      };
    }
    case FETCH_CATEGORY: {
      return {
        ...state,
        categories: action.payload?.map((list) => {
          return {
            value: list,
            status: false,
          };
        }),
      };
    }
    case IS_MOBILE_SEARCH: {
      state.isMobileSearch = action.payload;
      return {
        ...state,
      };
    }
    case SET_LANGUAGES: {
      state.languageSelected = action.payload;
      return {
        ...state,
      };
    }
    case REMOVE_LANGUAGES: {
      state.languageSelected = action.payload;
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
export default rootData;
